import { IUser } from '@@ting/models'

export const selectAuthorizationInitiated = (state: any) => state.auth.authInProcess
export const selectUser = (state: any): IUser => state.auth.user
export const selectIsAuthorized = (state: any) => !!selectUser(state)
